import { Fragment, useState } from "react";
import React from "react";
import { Dialog, Menu, Transition } from "@headlessui/react";
import { Link, Navigate } from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  ShoppingBagIcon,
  MenuAlt2Icon,
  UsersIcon,
  ArchiveIcon,
  XIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  ColorSwatchIcon,
  CogIcon,
  MinusIcon,
  PlusSmIcon as PlusSmIconSolid,
} from "@heroicons/react/solid";
import axios from "axios";

class InvoiceNumbermodal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      invoice_number_preference:[],
      invoice_number_preference_id:'',
      prefix:'',
      number:'',
      loader: "",
      overLay: "fixed inset-0 bg-black/50 ",
    };
    this.handleInput = this.handleInput.bind(this);
  }

  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };

  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };


  componentDidMount() {
   
    const token = localStorage.getItem("token");
    const res1 = axios
      .get("public/api/invoice/number/preferences", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res1) => {
        this.setState({ invoice_number_preference: res1.data.invoice_number_preference,prefix:res1.data.prefix,
        number:res1.data.number, });
        
        this.state.invoice_number_preference.map((invoicestatus,index)=>{
          
          if(invoicestatus.invoice_number_preference_status==1){
            this.state.invoice_number_preference_id=this.state.invoice_number_preference[index].id;
          }
          
         })
      });
  }

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleInputCustomer = (e) => {
    this.props.handleInputInvoiceNumber(e);
  };

  handleInputInvoicePreferrenceStatus=(index)=>(e)=>{
   
   this.state.invoice_number_preference_id=this.state.invoice_number_preference[index].id;
   
   this.state.invoice_number_preference.map((invoicestatus)=>{
    invoicestatus.invoice_number_preference_status=0;
    return invoicestatus;
   })

   this.state.invoice_number_preference[index].invoice_number_preference_status=1;
   this.setState({invoice_number_preference:this.state.invoice_number_preference});
    
  }
  

  saveCustomer = async (e) => {
    
    e.preventDefault();
   
    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post("public/api/invoice/number/preference/update", this.state, {
      headers,
    });

    if (res.data.success) {
      this.closeLoaderFuncion();
      this.setState({ showmsg: true });

      this.handleInputCustomer(res.data.success);
      setTimeout(
        function () {
          //Start the timer
          this.setState({ redirect: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
    } else {
      this.closeLoaderFuncion();
      this.setState({ error_list: res.data.data });
      //this.setState({ show: true })
    }
    this.closeLoaderFuncion();
  };

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  
  //Logout function

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.redirect) {
      //return <Navigate to={'/Customerlist'} />
    }


    return (
      <>
       
        <main className="flex-1">
          <div className="py-6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              <h1 className="text-2xl font-semibold text-gray-900">
                Invoice Number Preference
              </h1>
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              {/* Replace with your content */}

              <div className="hidden sm:block" aria-hidden="true">
                <div className="py-5">
                  <div className="border-t border-gray-200" />
                </div>
              </div>

              <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
                <div className="md:grid md:gap-6">
                  <div className="mt-5 md:mt-0 md:col-span-2">
                    <form onSubmit={this.saveCustomer}>
                      <div className="shadow overflow-hidden sm:rounded-md">
                        <div className="px-4 py-5 bg-white  sm:p-6" >
                        <div className="grid grid-cols-2 gap-6">
                        <div className="col-span-1 sm:col-span-1 lg:col-span-1">
                              <label className="text-base font-medium text-gray-900">Invoice Number</label>
                              <p className="text-sm leading-5 text-gray-500">Your invoice numbers are set on auto-generate mode</p>
                              <fieldset className="mt-4">
                                <legend className="sr-only">Invoice Number</legend>
                                <div className="space-y-4"  >
                                  {this.state.invoice_number_preference.map((notificationMethod,index) => (
                                    <div key={notificationMethod.id}  className="flex items-center" onChange={this.handleInputInvoicePreferrenceStatus(index)}>
                                      <input
                                        id={notificationMethod.id}
                                        name={notificationMethod.invoice_number_preference_status}
                                        type="radio"

                                        checked={notificationMethod.invoice_number_preference_status==1}
                                        className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                      />
                                      <label htmlFor={notificationMethod.id} className="ml-3 block text-sm font-medium text-gray-700">
                                        {notificationMethod.name}
                                      </label>
                                    </div>
                                  ))}
                                </div>
                              </fieldset>
                        </div>

                        <div className="col-span-1 sm:col-span-1 lg:col-span-1">
                        
                        {this.state.invoice_number_preference_id==1?(<div className="isolate -space-y-px rounded-md shadow-sm">
                          <div className="relative rounded-md rounded-b-none border border-gray-300 px-3 py-2 focus-within:z-10 focus-within:border-indigo-600 focus-within:ring-1 focus-within:ring-indigo-600">
                            <label htmlFor="prefix" className="block text-xs font-medium text-gray-900">
                              Invoice Prefix
                            </label>
                            <input
                              type="text"
                              name="prefix"
                              onChange={this.handleInput}
                              value={this.state.prefix}
                              id="prefix"
                              className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 sm:text-sm"
                              placeholder="INV"
                            />
                          </div>
                          <div className="relative rounded-md rounded-t-none border border-gray-300 px-3 py-2 focus-within:z-10 focus-within:border-indigo-600 focus-within:ring-1 focus-within:ring-indigo-600">
                            <label htmlFor="number" className="block text-xs font-medium text-gray-900">
                              Invoice number
                            </label>
                            <input
                              type="text"
                              name="number"
                              value={this.state.number}
                              onChange={this.handleInput}
                              id="number"
                              className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 sm:text-sm"
                              placeholder="123"
                            />
                          </div>
                        </div>  ):('')}
                        


                        </div>



                            </div>
                        </div>

                        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                          <button
                            type="submit"
                            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* /End replace */}
            </div>
          </div>
        </main>
        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        Successfully Saved
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </>
    );
  }
}

export default InvoiceNumbermodal;
